export const GroupsOrder = {
  '950000000000000000': 0, // Информационная продукция ЗАО "Интерфакс"
  '951000000000000000': 1, // Специальная информационная продукция
  '902000000000000000': 2, // Направления публикаций
  '900000000000000000': 3, // IPTC
  '925000000000000000': 4, // Макрогеографические регионы
  '901000000000000000': 5, // Страны мира и территории
  '082000000000000000': 6, // Административно-территориальные образования
  '905000000000000000': 7, // Коды РТС
  '910000000000000000': 8, // Коды СПБ
  '907000000000000000': 9, // Периодические издания
  '920000000000000000': 10, // Тип новости
} as const
